import React, { useRef, useEffect, useState } from 'react';
import MaskedInput from 'react-number-format';
import { useField } from '@unform/core';

const InputCurrency = ({ name, classRest, currency, cbChange, ...rest }) => {
  const inputRef = useRef(null);

  const { fieldName, registerField, error, clearError, defaultValue } =
    useField(name);

  const [value, setValue] = useState('');

  // Atualiza o valor quando o defaultValue muda (setData no Unform)
  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: () => value,
      setValue: (_, newValue) => {
        setValue(newValue);
      },
      clearValue: () => {
        setValue('');
      },
    });
  }, [fieldName, registerField, value]);

  const percentageProps = {
    thousandSeparator: '.',
    decimalSeparator: ',',
    decimalScale: 2,
    suffix: ' %',
    fixedDecimalScale: true,
    allowNegative: false,
    isNumericString: true,
  };

  const currencyMask = {
    prefix: 'R$ ',
    thousandSeparator: '.',
    decimalSeparator: ',',
    decimalScale: 2,
    thousandsGroupStyle: 'thousand',
    allowNegative: false,
    allowLeadingZeros: false,
    fixedDecimalScale: true,
    isNumericString: true,
  };

  return (
    <>
      {currency ? (
        <MaskedInput
          value={value}
          onValueChange={values => {
            const { floatValue } = values;
            setValue(floatValue);
            if (cbChange) {
              cbChange(floatValue);
            }
          }}
          id={fieldName}
          getInputRef={inputRef}
          inputMode="numeric"
          className={`form-control ${
            error && 'border-danger'
          } ${classRest} input-color`}
          onFocus={clearError}
          {...currencyMask}
          {...rest}
        />
      ) : (
        <MaskedInput
          value={value}
          onValueChange={values => {
            const { floatValue } = values;
            setValue(floatValue);
            if (cbChange) {
              cbChange(floatValue);
            }
          }}
          id={fieldName}
          getInputRef={inputRef}
          className={`form-control ${
            error && 'border-danger'
          } ${classRest} input-color`}
          onFocus={clearError}
          {...percentageProps}
          {...rest}
        />
      )}
      {error && <span className={error && 'text-danger'}>{error}</span>}
    </>
  );
};

export default InputCurrency;
